import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { VerifyEmailRequestDto } from "../generated/schema";

export function useVerifyEmail() {
	const mutation = $api.useMutation("post", "/auth/verify-email");

	return useMutation({
		mutationFn: async (data: VerifyEmailRequestDto) => {
			return mutation.mutateAsync({
				body: data,
				headers: {
					"x-auth-request": "true",
				},
			});
		},
	});
}
